import React from "react";
import Navbar from "../../../components/user/navbar/Navbar";
import SimpleBanner from "../../../components/user/general/SimpleBanner";
import Footer from "../../../components/user/footer/Footer";
import { Container, Row } from "react-bootstrap";
import MarqueeBanner from "../../../components/user/Marqueebanner/Marqueebanner";
import Notifications from "../../../components/user/notification/Notification";

const NotificationsPage = () => {
  return (
    <>
   
      <MarqueeBanner />
      <Navbar />
      <SimpleBanner
       
        title="Notification Page"
        subtitle="Because the Best Things Deserve to Wait."
        breadcrumbs={[
          { label: "Home", href: "/" },
          { label: "notificaitons", href: "/notifications" },
         
        ]}
      />
      <Container fluid>
      <Notifications />
    </Container>
     <Footer />
     </>
  );
};
export default NotificationsPage;
